/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
import * as React from "react";
import styled from "styled-components";
import { theme } from "../../../theme/theme";

const pencil = require("../../../svg/pencil-v2.svg");

const StyledEditLink = styled.a`
  background-color: #ffffff;
  border: 1px solid ${theme.color.gray300};
  border-radius: 50%;
  display: block;
  width: 25px;
  height: 25px;

  &:hover {
    background-color: #f4f6f6;
    border: 1px solid ${theme.color.gray300};
  }
`;

const StyledImage = styled.img`
  height: 15px;
  width: 12px;
`;

const EditCatalogItemIcon = ({
  brandName,
  catalogItemId,
}: {
  brandName: string;
  catalogItemId: string;
}): React.ReactElement => {
  return (
    <StyledEditLink
      data-testid={`edit-button-${catalogItemId}`}
      href={`/super_admin/items/${catalogItemId}`}
    >
      <StyledImage src={pencil} alt={`edit ${brandName}`} />
    </StyledEditLink>
  );
};

export default EditCatalogItemIcon;
